/**
 * Pick the tab host that owns a surface tab's area.
 * See docs/architecture/03-贡献点渲染与工作台布局.md.
 */
import type { TabHostApi, ViewArea } from '@hibro/shared';

export interface SurfaceTabHosts {
  /** Host for `auxiliaryBar` instance tabs. */
  readonly auxiliaryBar: TabHostApi;
  /** Host for editor instance tabs. Absent only when the shell has no editor strip. */
  readonly editor?: TabHostApi;
}

/**
 * An editor instance is not in the auxiliaryBar catalog. Looking it up there
 * never mounts the module's tab chrome, so the tab stays on the view title
 * declared at open time.
 */
export function selectSurfaceTabHost(
  area: ViewArea | undefined,
  hosts: SurfaceTabHosts,
): TabHostApi | undefined {
  if (area === 'editor') {
    return hosts.editor;
  }
  if (area === 'auxiliaryBar') {
    return hosts.auxiliaryBar;
  }
  return undefined;
}
